import React, { useEffect } from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import {
  AccountCircle,
  TransferWithinAStation,
  FlightLand,
  FlightTakeoff,
  MonetizationOn,
  LocationOn,
} from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../styles/App.scss';
import {
  STAFFS,
  VIEW_SERVICE_LIST_FROM,
} from '../../component/common/Routes/AppRoutes';
import PuffLoader from 'react-spinners/PuffLoader';
import CustomButton from '../../component/ui/FormFields/Button';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import StatusRadioGroup from '../../component/ui/FormFields/StatusRadioGroup';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetServiceDetails,
  serviceUpdateRequest,
  serviceViewRequest,
} from '../../redux/Service/ServiceAction';
import { toast, ToastContainer } from 'react-toastify';
import { resetUserDetails } from '../../redux/ProfileUpdate/profileUpdateAction';
import Loading from '../../component/ui/Loading';
export default function EditService() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(resetServiceDetails());
  }, []);
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const service = useSelector((state) => state.services?.Service); //this selector used for view
  const Editservice = useSelector((state) => state.services?.Service);
  const serviceData = service?.data?.data?.data;
  const viewLoading = service?.loading;
  const editLoading = service?.updateLoading;
  const successMessage = service?.success;
  const errorMessage = Editservice?.error;
  console.log('serviceData', serviceData);
  useEffect(() => {
    if (successMessage) {
      toast.success('Service Updated Successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetServiceDetails());
          navigate(VIEW_SERVICE_LIST_FROM);
        },
      });
    }
  }, [successMessage]);

  useEffect(() => {
    dispatch(serviceViewRequest(serviceId));
  }, [serviceId]);
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      services: '',
      service_type: '',
      arrival: '',
      departure: '',
      transist: '',
      price: '',
      airport: '',
      airport_type: '',
      transit_type: '',
    },
  });
  useEffect(() => {
    if (errorMessage) {
      setError('services', { type: 'manual', message: errorMessage });
      dispatch(resetServiceDetails());
    }
  }, [errorMessage]);

  const options = {
    serviceType: [
      { value: '1', label: 'Arrival' },
      { value: '2', label: 'Departure' },
      { value: '3', label: 'Transit' },
    ],
    typeOfAirport: [
      { value: '1', label: 'Domestic' },
      { value: '2', label: 'International' },
      { value: '3', label: 'Both' },
    ],
    transitServiceType: [
      { value: '0', label: 'International To Domestic' },
      { value: '1', label: 'Domestic To International' },
      { value: '2', label: 'Domestic To Domestic' },
      { value: '3', label: 'International To International' },
    ],
  };

  const selectedArrivalDepartureType = watch('arrival_departure_type');
  const isTransit = selectedArrivalDepartureType?.value === '3';

  useEffect(() => {
    dispatch(serviceViewRequest(serviceId));
  }, [serviceId, dispatch]);

  // Reset form with service data
  useEffect(() => {
    if (serviceData) {
      const arrivalDepartureType = options.serviceType.find(
        (option) =>
          option.value === serviceData.arrival_departure_type?.toString()
      ) || {
        label:
          serviceData.arrival_departure_type === '1'
            ? 'Arrival'
            : serviceData.arrival_departure_type === '2'
            ? 'Departure'
            : 'Transit',
        value: serviceData.arrival_departure_type,
      };

      const transitTypeOption = options.transitServiceType.find(
        (option) => option.value === serviceData.transit_type?.toString()
      );
      reset({
        services: serviceData.services || '',
        arrival_departure_type: arrivalDepartureType,

        arrival: serviceData.arrival || '',
        departure: serviceData.departure || '',
        transit: serviceData.transit || '',
        price: serviceData.price || '',

        service_type: serviceData.service_type
          ? options.typeOfAirport.find(
              (option) => option.value === serviceData.service_type
            ) || {
              label: serviceData.type_of_service,
              value: serviceData.service_type,
            }
          : null,
        status: serviceData.status === 1 ? 'Active' : 'Inactive',
        transit_type: transitTypeOption || '',
      });
    }
  }, [serviceData, reset]);
  if (viewLoading) {
    return <Loading text={' Loading service details...'} />;
  }

  const formFields = [
    {
      name: 'services',
      label: 'Service ',
      placeholder: 'Enter Service ',
      type: 'text',
      icon: <AccountCircle />,
      rules: { required: 'Service  is required' },
    },
    {
      name: 'arrival_departure_type',
      label: 'Arrival/Departure',
      placeholder: 'Select Type',

      options: options.serviceType,
      icon: <LocationOn />,
      rules: { required: 'Select Airport Type' },
    },

    // {
    //   name: "arrival",
    //   label: "Arrival",
    //   placeholder: "Enter Arrival Description",
    //   type: "text",
    //   icon: <FlightLand />,
    //   multiline: true
    //   //rules: { required: "Arrival description is required" },
    // },
    // {
    //   name: "departure",
    //   label: "Departure",
    //   placeholder: "Enter Departure Description",
    //   type: "text",
    //   icon: <FlightTakeoff />,
    //   multiline: true
    //   //  rules: { required: "Departure description is required" },
    // },
    // {
    //   name: "transit",
    //   label: "Transit",
    //   placeholder: "Enter Transit Description",
    //   type: "text",
    //   icon: <TransferWithinAStation />
    //   // rules: { required: "Transit description is required" },
    // },
    {
      name: 'service_type',
      label: 'Service Type',
      placeholder: 'Select Service Type',

      options: options.typeOfAirport,
      icon: <TransferWithinAStation />,
      rules: { required: 'Select Service Type' },
      sm: 12,
    },
    // {
    //   name: 'price',
    //   label: 'Price',
    //   placeholder: 'Enter Price',
    //   type: 'number',
    //   icon: <MonetizationOn />,
    //   rules: { required: 'Price is required' },
    // },
    ...(watch('arrival_departure_type')?.label === 'Transit'
      ? [
          {
            name: 'transit_type',
            label: 'Transit Service Type',
            placeholder: 'Select Transit Type',
            options: options.transitServiceType,
            icon: <LocationOn />,
            rules: { required: 'Select Transit Type' },
            sm: 12,
          },
        ]
      : []),
  ];

  if (viewLoading) {
    return <Loading text='Loading service details...' />;
  }

  return (
    <>
      <ToastContainer />
      <Box component={Paper} sx={{ margin: '30px', padding: '30px' }}>
        <Typography variant='h5' className='form-heading'>
          Edit Service
        </Typography>
        <Box className='add_service_form_heading'>
          <form
            onSubmit={handleSubmit(async (data) => {
              console.log('data', data);
              try {
                await dispatch(
                  serviceUpdateRequest({
                    ...data,
                    service_type: data.service_type?.value,
                    arrival_departure_type: (() => {
                      switch (data.arrival_departure_type?.label) {
                        case 'Arrival':
                          return '1';
                        case 'Departure':
                          return '2';
                        case 'Transit':
                          return '3';
                        default:
                          return null;
                      }
                    })(),
                    transit_type:
                      data.arrival_departure_type?.label === 'Transit'
                        ? (() => {
                            switch (data.transit_type?.label) {
                              case 'International To Domestic':
                                return '0';
                              case 'International To International':
                                return '3';
                              case 'Domestic To International':
                                return '1';
                              case 'Domestic To Domestic':
                                return '2';

                              default:
                                return null;
                            }
                          })()
                        : null,

                    price: data.price?.toString() || null,
                    status: data.status === 'Active' ? 1 : 2,
                    id: serviceId,
                  })
                );
              } catch (error) {
                console.error('Error submitting service data:', error);
                // Optionally show a notification to the user
              }
            })}
          >
            <Grid container spacing={2}>
              {formFields.map((field) => (
                <Grid
                  item
                  xs={12}
                  sm={
                    field.sm ||
                    (['Arrival', 'Departure', 'Transit'].includes(field.label)
                      ? 12
                      : 6)
                  }
                  key={field.name}
                >
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    placeholder={field.placeholder}
                    startAdornment={field.icon}
                    rules={field.rules}
                    value={field.value}
                    options={field.options}
                    type={field.type}
                    radioOptions={field.radioOptions}
                    error={!!errors[field.name]}
                    multiline={field.multiline}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}

              {/* Status */}
              <Grid item xs={12}>
                <StatusRadioGroup
                  name='status'
                  control={control}
                  defaultValue={
                    serviceData?.status === 1 ? 'Active' : 'Inactive'
                  }
                  rules={{ required: 'Status is required' }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box className='button-container'>
                  <CustomButton
                    variant='contained'
                    className='cancel-button'
                    type='button'
                    text='Back'
                    onClick={() => {
                      dispatch(resetServiceDetails());
                      navigate(-1);
                    }}
                  />
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    type='submit'
                    loading={editLoading}
                    text='update'
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </>
  );
}
